import React from 'react';
import PropTypes from 'prop-types';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Checkbox } from '@mui';

// Checkbox for the main map filters.
//
// The difference with the standard Checkbox is that it has no padding
// around the checkbox, and that we use smaller icons for the check mark
// (so there's more space for the label and hey have less truncation).
const FilterCheckbox = ({ checked, disabled, onChange, name = '' }) => (
  <Checkbox
    checked={checked}
    disabled={disabled}
    checkedIcon={<CheckBoxIcon style={{ fontSize: '1.125rem' }} />}
    icon={<CheckBoxOutlineBlankIcon style={{ fontSize: '1.125rem' }} />}
    onChange={onChange}
    size="small"
    style={{ padding: '0' }}
    name={name}
    inputProps={{ 'aria-label': name }}
  />
);

FilterCheckbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func
};

export default FilterCheckbox;
